import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { ZorroPayCardBackground } from '@zorro/shared/assets';
import { Box, Group } from '@zorro/web/design-system';

import { CardCopyButton } from './CardCopyButton';
import {
  CARD_HOLDER_MAX_WIDTH,
  CARD_VALUE_STYLE,
  MASKED_CVV,
} from './ZorroPayCardDetails.consts';

type ZorroPayMaskedCardVisualProps = {
  expDate: string;
  cardLastFour: string;
  nameOnCard: string;
};

const ZorroPayMaskedCardVisual = ({
  expDate,
  cardLastFour,
  nameOnCard,
}: ZorroPayMaskedCardVisualProps) => (
  <>
    <ZorroPayCardBackground style={{ marginLeft: '-0.625rem' }} />

    <Box pos="absolute" top={0} left={0} right={0} bottom={0}>
      <Box pos="absolute" top="55%" left="7%">
        <Box
          c="rgba(255,255,255,0.75)"
          fz="var(--font-size-14)"
          lh={1.3}
          mb={2}
        >
          Card Holder
        </Box>
        <Group gap={4} align="center" wrap="nowrap">
          <Tooltip label={nameOnCard} disabled={!nameOnCard}>
            <Box
              maw={CARD_HOLDER_MAX_WIDTH}
              style={{
                ...CARD_VALUE_STYLE,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {nameOnCard || '—'}
            </Box>
          </Tooltip>
          {nameOnCard && (
            <CardCopyButton
              text={nameOnCard}
              ariaLabel="Copy card holder name"
            />
          )}
        </Group>
      </Box>

      <Box pos="absolute" top="55%" left="46%">
        <Box
          c="rgba(255,255,255,0.75)"
          fz="var(--font-size-14)"
          lh={1.3}
          mb={2}
        >
          Expires
        </Box>
        <Group gap={4} align="center" wrap="nowrap">
          <Box style={CARD_VALUE_STYLE}>{expDate || '—'}</Box>
          {expDate && (
            <CardCopyButton text={expDate} ariaLabel="Copy expiry date" />
          )}
        </Group>
      </Box>

      {/* CVV — no reveal happens on this page; always masked */}
      <Box pos="absolute" top="55%" left="74%">
        <Box
          c="rgba(255,255,255,0.75)"
          fz="var(--font-size-14)"
          lh={1.3}
          mb={2}
        >
          CVV
        </Box>
        <Box style={CARD_VALUE_STYLE}>{MASKED_CVV}</Box>
      </Box>

      <Box
        pos="absolute"
        top="79.64%"
        left="7%"
        w={300}
        style={{ overflow: 'hidden' }}
      >
        <Box w="100%" style={{ ...CARD_VALUE_STYLE, letterSpacing: '0.05em' }}>
          {`•••• •••• •••• ${cardLastFour || '••••'}`}
        </Box>
      </Box>
    </Box>
  </>
);

export { ZorroPayMaskedCardVisual };
